import { createSlice } from "@reduxjs/toolkit";
import appConst from "../Utilities/appConst.json";

const footerSlice = createSlice({
  name: "footer",
  initialState: {
    summary: {
      quantity: null,
      quantityDiscount: null,
      additionalDiscount: null,
      shippingDiscount: null,
      total: null,
      shipping: null,
      tempQuantityDiscount: null,
      tempAdditionalDiscount: null,
      tempShippingDiscount: null,
      tempTotal: null,
      tempShipping: null,
    },
    nextPage: "",
    currentPage: "",
    btnText: "",
    beforeContinue: undefined,
    isShow: false,
    isDisable: false,
    background: appConst.LUPA_GREEN_COLOR,
    color: appConst.LUPA_ENABLE_FONT_COLOR,
    footerContentHeight: 0,
    showPrices: true,
  },
  reducers: {
    getFooter: (state, action) => {
      return state;
    },
    setFooterFromBasket: (state, action) => {
      state.summary.quantity = action.payload.quantity;
      state.summary.quantityDiscount = action.payload.quantityDiscount;
      state.summary.additionalDiscount = action.payload.additionalDiscount;
      state.summary.shippingDiscount = action.payload.shippingDiscount;
      state.summary.total = action.payload.total;
      state.summary.priceList = action.payload.priceList;
      state.summary.shipping = null;
      state.summary.tempQuantityDiscount = null;
      state.summary.tempAdditionalDiscount = null;
      state.summary.tempShippingDiscount = null;
      state.summary.totalwithoutShipping = action.payload.total;
      state.summary.tempShipping = null;
    },
    setTempFooterFromShipping: (state, action) => {
      state.summary.tempTotal = action.payload.tempTotal;
      state.summary.tempShippingDiscount = action.payload.tempShippingDiscount;
      state.summary.tempAdditionalDiscount =
        action.payload.tempAdditionalDiscount;
      state.summary.shipping = action.payload.shipping;
      state.summary.tempShipping = action.payload.shipping;
    },
    setFooterFromShipping: (state, action) => {
      state.summary.total = state.summary.tempTotal;
      state.summary.additionalDiscount = state.summary.tempAdditionalDiscount;
      state.summary.shippingDiscount = state.summary.shippingDiscount;
    },
    setFooterFromSelectedCoupons: (state, action) => {
      state.summary.tempShippingDiscount = action.payload.tempShippingDiscount;
      state.summary.tempAdditionalDiscount =
        action.payload.tempAdditionalDiscount;
      state.summary.tempTotal = action.payload.tempTotal;
      state.summary.tempShipping = action.payload.tempShipping;
      state.summary.priceList =
        action.payload.priceList || state.summary.priceList;
    },
    setFooterFromSummary: (state, action) => {
      state.summary.total = action.payload.total || state.summary.total;
    },
    setFooterShippingFromUpdateCoupons: (state, action) => {
      state.summary.shipping = action.payload;
    },
    setFooterQunatityFromCoupons: (state, action) => {
      state.summary.quantity = action.payload;
    },
    setNextPage: (state, action) => {
      state.nextPage = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setBtnText: (state, action) => {
      state.btnText = action.payload;
    },
    setBeforeContinue: (state, action) => {
      state.beforeContinue = action.payload;
    },
    setIsShow: (state, action) => {
      state.isShow = action.payload;
    },
    setDisable: (state, action) => {
      state.isDisable = action.payload;
    },
    setBackground: (state, action) => {
      state.background = action.payload;
    },
    setColor: (state, action) => {
      state.color = action.payload;
    },
    setFooterContentHeight: (state, action) => {
      state.footerContentHeight = action.payload;
    },
    setShowPrices: (state, action) => {
      state.showPrices = action.payload;
    },
  },
});

export const footerActions = footerSlice.actions;
export default footerSlice;
